module.exports = __webpack_public_path__ + "ef83c5c33c8837992eb27a1ade9e6754.woff2";